import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './_InfiniteScroll.scss';

export default class InfiniteScrollItemContainer extends Component {
  componentDidMount() {
    this.height = this.containerRef.offsetHeight;

    this.resizeObserver = new ResizeObserver((entries, observer) => {
      const entry = entries[0];
      if (entry) {
        const currentHeight = entry.contentRect.height;
        if (!this.props.hidden && this.height !== currentHeight) {
          this.height = currentHeight;
          this.triggerResizeCB();
        }
      }
    });

    this.resizeObserver.observe(this.containerRef);
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.hidden) {
      this.resizeObserver.unobserve(this.containerRef);
    } else {
      this.resizeObserver.observe(this.containerRef);
    }
  }

  triggerResizeCB() {
    this.props.onItemResize(this.props.itemIndex, this.containerRef.offsetHeight);
  }

  render() {
    const isHidden = this.props.hidden;
    const classes = classNames('InfiniteScroll__item-container', { hidden: isHidden });

    return (
      <div
        className={classes}
        ref={ref => {
          this.containerRef = ref;
        }}
      >
        {this.props.item}
      </div>
    );
  }
}

InfiniteScrollItemContainer.propTypes = {
  /**
   * A renderable node to put inside the container.
   */
  item: PropTypes.node.isRequired,
  /**
   * A callback to trigger when the item's size has been changed.
   */
  onItemResize: PropTypes.func.isRequired,
  /**
   * Item's index.
   */
  itemIndex: PropTypes.number.isRequired,
  /**
   * A flag indicates if the the item should be hidden.
   */
  hidden: PropTypes.bool
};
